export const KEN  = 'KEN';
export const IS_KONE = 'isKone';
export const COUNTRY_CODE = 'countryCode';
export const SITE_LOCATION = 'siteLocation';
export const SERVICE_ORDER = 'serviceOrder';
export const NO_OF_FLOORS = 'noOfFloors';
export const CREATED_BY = 'createdBy';
export const REPAIR_PACKAGES = 'repairPackages';
export const SERVER_TIMED_OUT = 'serverTimedOut';
export const NO_RESPONSE = 'NO_RESPONSE';
export const GEARED = 'GEARED';
export const GEARLESS = 'GEARLESS';
export const HYDRAULIC = 'HYDRAULIC';

export const ERR_NETWORK = 'ERR_NETWORK';